// extracted by mini-css-extract-plugin
export var cardHeader = "_fh-0";
export var reorderHandle = "_fh-3";
export var titleArea = "_fh-1";
export var titleAreaWithHandle = "_fh-2";